var render, staticRenderFns
import script from "./DesignTimeSupport.vue?vue&type=script&lang=js&"
export * from "./DesignTimeSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ac25b",
  null
  
)

export default component.exports